const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/InputField/InputField.tsx';
import Input from '@mui/material/Input';
import { useTheme } from '@mui/material/styles';
import { useCSSClasses } from './styles';
import textMap from '../translations';
import { useIntl } from 'react-intl';
import { cx } from '@emotion/css';
import { LoginStage } from 'App/pages';
import useBreakpoint from '@cistec/common_web/hooks/useBreakpoint';
import { ReactNode } from 'react';

interface Props {
    stage: LoginStage;
    isValueMissing?: boolean;
    isValueBad?: boolean;
    externalError?: string | ReactNode;
    disabled?: boolean;
    mask?: string;
    defaultValue?: string;
    type?: 'number' | 'text';
    id?: string;
    value?: string;
}

export const InputField = (props: Props) => {
    const theme = useTheme();
    const isSmallDevice = useBreakpoint(theme?.breakpoints?.values?.sm);
    const classes = useCSSClasses();
    const { formatMessage } = useIntl();
    const name = props.stage;
    const hint = formatMessage(props.stage === 'invitation-code' ? textMap.invitationCodeHint : textMap.smsCodeHint);

    const elementProps = {
        autoFocus: true,
        defaultValue: props.defaultValue,
        disabled: props.disabled,
        fullWidth: true,
        id: props.id,
        placeholder: hint,
        classes: classes,
    };
    // TODO: REFACTOR USE THE CORRECT FIELD WHERE IT SHOULD.
    return (
        <div
            className={cx(
                classes.frame,
                props.mask ? classes.maskFrame : undefined,
                isSmallDevice ? classes.smallDevice : undefined
            )}
        >
            {props.type === 'number' && isSmallDevice ? (
                // try to let number keyboard appear on devices using pattern
                <Input name={name} inputProps={{ style: { textAlign: 'center' }, pattern: '\\d*' }} {...elementProps} />
            ) : (
                <Input name={name} inputProps={{ style: { textAlign: 'center' } }} {...elementProps} />
            )}
        </div>
    );
};
